import {Injectable} from '@angular/core';
import {ApiService} from "../../../../../shared/services/api/api.service";
import {Observable} from "rxjs";
import {IPagination} from "../../../../../shared/services/api/interface/pagination.interface";

@Injectable({
  providedIn: 'root'
})
export class FormService {

  constructor(private readonly apiService: ApiService) {
  }

  getFilter(event: any, filter: any): Observable<IPagination> {
    const filterParams = {
      ...filter,
      formMenuId: filter['formMenuId'] // Form menüsüne göre filtreleme yapıyoruz
    };
    return this.apiService.getFilter<IPagination>(`form/form-filter-list`, {event: event, filter: filterParams})
  }

  getList() {
    return this.apiService.get<any[]>('form');
  }

  getById(id: any) {
    return this.apiService.get(`form/${id}`);
  }

  create(data: any) {
    return this.apiService.post('form/create', data);
  }

  update(data: any) {
    return this.apiService.patch('form/update', data);
  }

  delete(id: number) {
    return this.apiService.delete(`form/delete/${id}`);
  }

  dropdownFormByOperationVehicle(data: any) {
    return this.apiService.post<any[]>('form/get-dropdown-form-operation-vehicle', data);
  }

  getAnswersByFilters(data: any) {
    return this.apiService.post<any[]>('form-tab-answers', data);
  }

}
